import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { IAuthService } from '../interfaces/i-auth.service';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject<IAuthService>('IAuthService' as any);
  const token = authService.getJwtToken();

  if (token && !req.url.includes('graph.facebook.com')) {
    req = req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + token),
    });
  }

  return next(req);
};
